export default "__VITE_ASSET__a380292b__"